<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { getAlmInfo } from "@/backend/read/BackendReader";
import { cardKey } from "@/components/StickyNote/injectKeys";
import UserSelector from "@/components/UserSelector/UserSelector.vue";
import BasePopupTitle from "@/components/ui/BasePopup/BasePopupTitle.vue";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import InfoMessage from "@/components/ui/InfoMessage/InfoMessage.vue";
import type { AuthUser } from "@/model/user";
import { isStickyTypeAlmSynced } from "@/store/stickyType";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const dropdown = injectStrict(dropdownKey);

const canAssign = computed(() => getAlmInfo().hasAssignee || !isStickyTypeAlmSynced(card.type));

function setAssignee(user: AuthUser | null) {
  cardActions.setAssignee("action-menu", card.id, user);
  dropdown.close();
}
</script>

<template>
  <div class="set-assignee">
    <UserSelector v-if="canAssign" :selected="card.assignee" @select="setAssignee" />
    <template v-else>
      <BasePopupTitle v-autofocus>{{ $t("general.assignee") }}</BasePopupTitle>
      <InfoMessage>
        {{ $t("assignee.cannotSet", { almType: getAlmInfo().name }) }}
      </InfoMessage>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.set-assignee {
  width: 240px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
